<app-rad-base-modal
    #radBaseModal
    [identifier]="modalType"
    [closable]="closable"
    [closeButtonText]="closeButtonText" 
    [confirmButtonText]="'Select'"
    [disableConfirmButton]="!canConfirm"
    [showNewButton]="false"
    [modalZIndex]="999"
    modalHeight="calc(100vh - 252px)"
    modalWidth="calc(100vw - 252px)"
    [title]="'Resource Matcher'"
    (onConfirm)="confirmSelection()"
>
    <div style="height: 100%; overflow: hidden;">
        <div class="resource-matcher-modal">
            <!-- Left side: Resource Chooser -->
            <div class="resource-matcher-modal__left">

                <div class="resource-matcher-modal__search-container" *ngIf="gridOptions && chooserServerSideParams">
                    <app-resource-chooser
                        [title]="'Select ' + (resourceDictionary?.displayNamePlural || 'resources')"
                        [searchPlaceHolderText]="searchPlaceHolderText"
                        [rowSelection]="'single'"
                        [gridOptions]="gridOptions"
                        [chooserServerSideDataParams]="chooserServerSideParams"
                        [hasMatcher]="false"
                        [resourceType]="resourceType"
                        [disableHoverEffects]="true"
                        debounceTime="300">
                        </app-resource-chooser>
                </div>
            </div>

            <!-- Right side: Pairing Table -->
            <div class="resource-matcher-modal__right">
                <div class="resource-matcher-modal__dropzones">
                    <div class="dropzone-column" *ngFor="let column of columns">
                        <h3 class="dropzone-header">{{ column?.label }}</h3>
                        <div class="dropzone-slots">
                            <app-resource-drop-slot
                                *ngFor="let row of pairingRows; let i = index"
                                [resource]="row.columns[column?.id]"
                                [resourceType]="resourceType"
                                [columnId]="column?.id"
                                [rowIndex]="row.rowIndex"
                                [isDragOver]="isSlotHovered(row.rowIndex, column?.id)"
                                [attr.data-slot-row]="row.rowIndex"
                                [attr.data-slot-column]="column?.id"
                                (resourceRemoved)="removeResourceFromSlot($event.rowIndex, $event.columnId)">
                            </app-resource-drop-slot>
                        </div>
                    </div>
                </div>

                <!-- Bottom section fixed at bottom of right side -->
                <div class="bottom-section">
                    <div style="display: flex;" *ngIf="synchronousErrors.length === 0">
                        <rad-icon
                            class="rad-theme--light valid-icon" 
                            name="checkmark" 
                            size="sm"
                            style="
                            margin-right: 4px;
                            padding-top: 4px;
                            ">
                            </rad-icon>
                        <div>All pairs are valid.</div>
                    </div>

                    <div *ngIf="synchronousErrors.length > 0">
                        <rad-popover 
                        position="top"
                        style="z-index: 9999;"
                        >
                            <rad-icon
                            class="rad-theme--light error-icon" 
                            name="exclamationTriangle" 
                            size="sm"
                            style="
                            margin-right: 4px;
                            padding-top: 4px;
                            ">
                            </rad-icon>
                            <div class="error-details">
                                Error details
                            </div>
                            
                            <rad-popover-custom-content>
                                <div
                                style="
                                font-size: 16px; 
                                font-weight: 400; 
                                line-height: 140%; 
                                color: #464247; 
                                width: 300px;
                                margin-top: 0px;
                                margin-bottom: 0px;
                                ">
                                    <div class="error-message" *ngFor="let error of synchronousErrors">
                                        {{error}}
                                    </div>
                                </div>
                                
                            </rad-popover-custom-content>
                        </rad-popover>
                    </div>
                </div>

            </div>
        </div>
    </div>
</app-rad-base-modal>

